<!-- ════════════════════════════════════════════════════════════════
     V3 DESIGN — Tab Bar
     ════════════════════════════════════════════════════════════════ -->
<ng-container *ngIf="designVersion === 'v3'">
  <!-- Chevron wrapper mirrors admin-hor-menu's [left][scrolling tabs][right]
       flex row (_horizontal-tabs.scss). Arrows render only when the strip
       actually overflows (hasOverflow — kept fresh by checkOverflow() on
       init / data change / resize). `scrollContainer1` id reuses the
       component's existing scrollLeft()/scrollRight(); no clash with the
       V2 <ul> below since only one designVersion branch renders. -->
  <div class="jc-v3-tab-bar-wrap">
    <div class="jc-v3-tab-scroll-btn" *ngIf="hasOverflow">
      <div id="job_portfolio_v3_scroll_left_button" (click)="scrollLeft()">
        <ng-icon name="tablerChevronLeft"></ng-icon>
      </div>
    </div>
  <div class="jc-v3-tab-bar" id="scrollContainer1">
    <button class="jc-v3-tab-btn" [class.active]="pageName === 'job-details'"
      (click)="onChange('job-details')">Details</button>

    <button class="jc-v3-tab-btn" *ngIf="jobData?.jobPostedBy === userId"
      [class.active]="pageName === 'job-applicants'" (click)="onChange('job-applicants')">Applicants</button>

    <button class="jc-v3-tab-btn" *ngIf="jobData?.jobPostedBy !== userId && userType !== 'RECRUITER'"
      [class.active]="pageName === 'candidate-applied'" (click)="onChange('candidate-applied')">Candidate Applied</button>

    <button class="jc-v3-tab-btn" *ngIf="jobData?.jobPostedBy !== userId && showSubContractButton"
      [class.active]="pageName === 'job-applicants'" (click)="onChange('job-applicants')">Applicants</button>

    <button class="jc-v3-tab-btn" *ngIf="jobData?.jobPostedBy === userId"
      [class.active]="pageName === 'talent-pool'" (click)="onChange('talent-pool')">Talent Pool</button>

    <button class="jc-v3-tab-btn" *ngIf="jobData?.jobPostedBy === userId"
      [class.active]="pageName === 'suggested-candidates'" (click)="onChange('suggested-candidates')">Marketplace Candidates</button>

    <button class="jc-v3-tab-btn" *ngIf="jobData?.jobPostedBy === userId"
      [class.active]="pageName === 'resume-requests'" (click)="onChange('resume-requests')">Resume Requests</button>

    <button class="jc-v3-tab-btn" *ngIf="jobData?.jobPostedBy === userId"
      [class.active]="pageName === 'candidates-invited'" (click)="onChange('candidates-invited')">Candidates Invited</button>

    <button class="jc-v3-tab-btn" *ngIf="jobData?.jobPostedBy === userId"
      [class.active]="pageName === 'jobs-viewed'" (click)="onChange('jobs-viewed')">Views</button>

    <button class="jc-v3-tab-btn" *ngIf="jobData?.jobPostedBy === userId"
      [class.active]="pageName === 'jobs-liked'" (click)="onChange('jobs-liked')">Likes</button>

    <button class="jc-v3-tab-btn" *ngIf="jobData?.jobPostedBy === userId"
      [class.active]="pageName === 'jobs-activity'" (click)="onChange('jobs-activity')">Event Logs</button>
  </div>
    <div class="jc-v3-tab-scroll-btn" *ngIf="hasOverflow">
      <div id="job_portfolio_v3_scroll_right_button" (click)="scrollRight()">
        <ng-icon name="tablerChevronRight"></ng-icon>
      </div>
    </div>
  </div>
</ng-container>

<!-- ════════════════════════════════════════════════════════════════
     V2 DESIGN (existing) — Tab Bar
     ════════════════════════════════════════════════════════════════ -->
<ng-container *ngIf="designVersion !== 'v3'">
<div *ngIf="jobData?.jobPostedBy==userId" (mouseenter)="onMouseEnter1()" (mouseleave)="onMouseLeave1()"
    class="show-hidden-design-left">
    <div *ngIf="showChevron || showChevron1" class="left-scroll-buttons" style="top: 10px;">
        <div id="job-portfolio-scroll-left-btn" (click)="scrollLeft()">
            <ng-icon name="tablerChevronLeft"></ng-icon>
        </div>
    </div>
</div>

<div class="hpanel br-none">
    <div class="panel-body pad-0 job-portfolio-header border-radius-top-left-right-6 border-radius-bottom-left-right-0" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
        <ul class="nav navbar-nav menu-scroll-view " [ngClass]="{'menu-scroll-view-1': jobData?.jobPostedBy != userId}"
            id="scrollContainer1">
            <li id="job-details" display="dynamic" class="menu-item" [ngClass]="{'active': pageName=='job-details'}"
                routerLinkActive="router-link-active" title="Details" (click)="onChange('job-details')">
                <a id="job-details-link">
                    Details
                </a>
            </li>
            <li id="candidate-applied" *ngIf="jobData?.jobPostedBy!=userId && userType!='RECRUITER'" display="dynamic"
                (click)="onChange('candidate-applied')" [ngClass]="{'active': pageName=='candidate-applied'}"
                class="menu-item" routerLinkActive="router-link-active" title="Candidate Applied">
                <a id="candidate-applied-link">
                    Candidate Applied
                </a>
            </li>
            <li id="job-applicants" *ngIf="jobData?.jobPostedBy==userId" display="dynamic" (click)="onChange('job-applicants')"
                [ngClass]="{'active': pageName=='job-applicants'}" class="menu-item"
                routerLinkActive="router-link-active" title="Applicants">
                <a id="job-applicants-link">
                    Applicants
                </a>
            </li>
            <li id="job-applicants" *ngIf="jobData?.jobPostedBy!=userId && showSubContractButton" display="dynamic" (click)="onChange('job-applicants')"
                [ngClass]="{'active': pageName=='job-applicants'}" class="menu-item"
                routerLinkActive="router-link-active" title="Applicants">
                <a id="job-applicants-link">
                    Applicants
                </a>
            </li>
            <li id="talent-pool" *ngIf="jobData?.jobPostedBy==userId" display="dynamic" (click)="onChange('talent-pool')"
                [ngClass]="{'active': pageName=='talent-pool'}" class="menu-item"
                routerLinkActive="router-link-active" title="Talent Pool">
                <a id="talent-pool-link">
                    Talent Pool
                </a>
            </li>
            <li id="resume-requests" *ngIf="jobData?.jobPostedBy==userId" display="dynamic" (click)="onChange('resume-requests')"
                [ngClass]="{'active': pageName=='resume-requests'}" class="menu-item"
                routerLinkActive="router-link-active" title="Resume Requests">
                <a id="resume-requests-link">
                    Resume Requests
                </a>
            </li>
                <li id="suggested-candidates" *ngIf="jobData?.jobPostedBy==userId" display="dynamic" (click)="onChange('suggested-candidates')"
                [ngClass]="{'active': pageName=='suggested-candidates'}" class="menu-item"
                routerLinkActive="router-link-active" title="Marketplace Candidates">
                <a id="suggested-candidates-link">
                    Marketplace Candidates
                </a>
            </li>
            <li id="candidates-invited" *ngIf="jobData?.jobPostedBy==userId" display="dynamic" (click)="onChange('candidates-invited')"
                [ngClass]="{'active': pageName=='candidates-invited'}" class="menu-item"
                routerLinkActive="router-link-active" title="Candidates Invited">
                <a id="candidates-invited-link">
                    Candidates Invited
                </a>
            </li>
            <!-- to be used in the upcoming changes -->
            <!-- <li *ngIf="jobData?.jobPostedBy==userId" display="dynamic" class="menu-item"
                routerLinkActive="router-link-active" title="Company">
                <a>
                    Company
                </a>
            </li> -->
            <li id="jobs-viewed" *ngIf="jobData?.jobPostedBy==userId" [ngClass]="{'active': pageName=='jobs-viewed'}"
                (click)="onChange('jobs-viewed')" display="dynamic" class="menu-item"
                routerLinkActive="router-link-active" title="Views">
                <a id="jobs-viewed-link">
                    Views
                </a>
            </li>
            <li id="jobs-liked" *ngIf="jobData?.jobPostedBy==userId" [ngClass]="{'active': pageName=='jobs-liked'}"
                (click)="onChange('jobs-liked')" display="dynamic" class="menu-item"
                routerLinkActive="router-link-active" title="Likes">
                <a id="jobs-liked-link"> Likes </a>
            </li>
            <li id="jobs-activity" *ngIf="jobData?.jobPostedBy==userId" [ngClass]="{'active': pageName=='jobs-activity'}"
                (click)="onChange('jobs-activity')" display="dynamic" class="menu-item"
                routerLinkActive="router-link-active" title="Event Logs">
                <a id="jobs-activity-link"> Event Logs </a>
            </li>
        </ul>
    </div>
</div>


<div *ngIf="jobData?.jobPostedBy==userId" (mouseenter)="onMouseEnter1()" (mouseleave)="onMouseLeave1()"
    class="show-hidden-design-right">
    <div *ngIf="showChevron || showChevron1" class="right-scroll-buttons">
        <div id="job-portfolio-scroll-right-btn" (click)="scrollRight()">
            <ng-icon name="tablerChevronRight"></ng-icon>
        </div>
    </div>
</div>
</ng-container>
